import { bl_ppl_from_peppol_generic_doc_hdr_RowClass, bl_ppl_from_peppol_generic_doc_line_RowClass } from '../../../dbschema';
import { BaseContainerModel } from  '../../base-container.model';

export class PeppolFromPeppolGenericDocHdrLineContainerModel extends BaseContainerModel {
    bl_ppl_from_peppol_generic_doc_hdr: bl_ppl_from_peppol_generic_doc_hdr_RowClass = new bl_ppl_from_peppol_generic_doc_hdr_RowClass();
    bl_ppl_from_peppol_generic_doc_lines: bl_ppl_from_peppol_generic_doc_line_RowClass[] = [];
}
